import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { useState } from "react";
import { baseUrl, redirectUrl } from "config";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

//--------// APIS_USED_FOR_THIS_COMPONENT //---------//
const changeBatchApi = "/changeBatch";
const printApi = "/ChangeBatchPrint";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: 2,
};

function ChangeBatch({ handleDialogClose }) {
  const navigate = useNavigate();
  const posHeader = useSelector((state) => state.posHeader);
  const posSlice = useSelector((state) => state.posSlice);

  // Use BatchNo from posHeader (B2B) or posSlice (POS Tables/B2C)
  const currentBatchNo = posHeader?.BatchNo || posSlice?.BatchNo || 0;

  const [open, setOpen] = useState(false);

  const [batchForm, setBatchForm] = useState({
    closing_balance: 0,
    actual_cash: 0,
    actual_bank: 0,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBatchForm((prevForm) => ({
      ...prevForm,
      [name]: parseFloat(value),
    }));
  };
  const handleClose = () => {
    setOpen(false);
    axios({
      method: "post",
      url: baseUrl + "/logout",
      withCredentials: true,
    })
      .then((res) => {
        redirectUrl();
      })
      .catch((err) => {
        if (err.response.status === 403 || err.response.status === 401)
          redirectUrl();
      });
  };

  const handleSubmit = () => {
    axios
      .post(
        baseUrl + changeBatchApi,
        {
          amount: batchForm,
          batchNo: currentBatchNo,
          toDate: dayjs(),
        },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data.success) {
          // navigate('/login');
          setOpen(true);
        }
      })
      .catch((error) => {
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      });
  };
  const handlePrint = () => {
    axios
      .post(
        baseUrl + printApi,
        { batchNo: currentBatchNo },
        { withCredentials: true }
      )
      .then((res) => {
        navigate("/printer/batchPrint", {
          state: { data: res.data, form: batchForm },
        });
      })
      .catch((error) => {
        if (
          (error.response && error.response.status === 403) ||
          error.response.status === 401
        ) {
          redirectUrl();
        }
      });
  };
  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h3" component="h2">
            Alert
          </Typography>
          <Typography
            id="modal-modal-description"
            variant="h4"
            sx={{ my: 2, px: 2 }}
          >
            Do you want to print this batch report?
          </Typography>
          <Stack direction={"row"} gap={2} justifyContent={"flex-end"}>
            <Button variant="outlined" color="info" onClick={handleClose}>
              No
            </Button>
            <Button variant="contained" color="info" onClick={handlePrint}>
              Yes
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Box width={350} sx={{ p: 1.5 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              Change Batch
            </Typography>{" "}
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              name="closing_balance"
              size="small"
              label="Actual Amount"
              inputProps={{
                min: 0,
                max: 9,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              value={batchForm.closing_balance}
              onChange={handleInputChange}
              onFocus={(e) => e.target.select()}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              name="actual_cash"
              size="small"
              label="Cash Amount"
              inputProps={{
                min: 0,
                max: 9,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              value={batchForm.actual_cash}
              onChange={handleInputChange}
              onFocus={(e) => e.target.select()}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              name="actual_bank"
              size="small"
              label="Bank Amount"
              inputProps={{
                min: 0,
                max: 9,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              value={batchForm.actual_bank}
              onChange={handleInputChange}
              onFocus={(e) => e.target.select()}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              color="info"
              onClick={() => handleDialogClose(false)}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              color="info"
              onClick={handleSubmit}
              disabled={!batchForm.closing_balance > 0}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default ChangeBatch;
